import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from 'components/library/Button/Button';
import styles from './Modal.module.css';
import stylesModal from './SuccessEligibleModal.module.css';

interface Props {
  createProject: () => void;
  successCreateProject?: boolean;
  alreadyUsed: boolean;
  setModalState: (value: number) => void;
  closeModal: () => void;
  auth: boolean;
  amountSought: number;
};

export default function WaitingCreateModal({
  createProject, successCreateProject, alreadyUsed,
  setModalState, closeModal, auth, amountSought,
}: Props) {
  const { t } = useTranslation();
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      if (auth && successCreateProject === undefined) {
        await createProject();
      }
      if (alreadyUsed) setModalState(4);
    };

    fetchData()
      .catch((error) => {
        console.error("An error occurred in useEffect:", error);
        setError(error);
      });
  }, [successCreateProject, setError, auth, alreadyUsed]);

  return (
    <div className={styles.bodyModal}>
      {successCreateProject ? (
        <>
          <div className={styles.bodyModal}>
            <div>
              <h1 className={stylesModal.icon}><span className={`${stylesModal.materialIcons} material-icons`}>check_circle</span></h1>
            </div>
            <h3>{t('modal.successTitle')}</h3>
            <p className={`${styles.text}`}>{t('modal.successDescription', { minAmount: Number.parseFloat(amountSought.toString()).toLocaleString(undefined, { minimumFractionDigits: 2 }) })}</p>
            <p className={`${styles.text}`}>{t('modal.successDescriptionSecond')}</p>
            <Button
              className={styles.button}
              variant="fill"
              type="secondary"
              label={t('modal.successButton')}
              onButtonClick={() => navigate('/invoicingForm')}
            />
          </div>
        </>
      ) : <h3>{t('modal.waitingCreated')}</h3>}
      {error ? (
        <>
          <p className={`${styles.error} ${styles.text} ${styles.font30}`}>{t('modal.invalidMessage')}</p>
          <Button
            className={styles.button}
            variant="fill"
            type="secondary"
            label={t('modal.invalidButton')}
            onButtonClick={() => closeModal()}
          />
        </>
      ) : <></>}
      <p className={`${styles.text} ${styles.font14}`}>
        {t('modal.successHelper')}
        &nbsp;
        <Button
          className={styles.ghostButton}
          variant="ghost"
          type="secondary"
          label={t('navigation.takeRdv')}
          onButtonClick={() => window.open(`https://vc${process.env.REACT_APP_DEBUG ? '-dev' : ''}.ayomi.fr?utm_source=home-10`)}
        />
      </p>
    </div>
  );
}
